import { useQuery } from 'query';

import { loadUserDetails } from '../sources/user';
import { details } from './queryKeyFactory';

export const useUserDetails = () => {
  return useQuery(
    details(),
    async () => {
      return loadUserDetails();
    },
    {
      onError: () => {
        //skip error handling
      },
    }
  );
};
